module.exports = __webpack_public_path__ + "img/messagebird.64ae89e5.gif";